import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { TreeProgramTopHeader } from 'components/common';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { EditBulkActionRules } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/EditBulkActionRules/EditBulkActionRules';
import { EditBulkTagsRules } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/EditBulkTagsRules/EditBulkTagsRules';

export const EditBulkActionRulesPage = () => {
    useFullStoryPageView({ pageName: projectConfig.editBulkActionRules.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <TreeProgramTopHeader
                    showBack={true}
                    pageTitle={projectConfig.editBulkActionRules.title}
                    versionSelectorEnabled={false}
                    isDisabled={true}
                />
            </HeaderWrapper>

            <MainContent>
                <EditBulkActionRules />
                <EditBulkTagsRules />
            </MainContent>
        </PageContainer>
    );
};
